export default __webpack_public_path__ + "static/media/Brigand's Armbands of the Ritual Flame.ad482532.jpg";